import { createClient } from '@supabase/supabase-js';

// CRM usa suas PRÓPRIAS variáveis (prefixo _CRM_)
const SUPABASE_URL = process.env.REACT_APP_CRM_SUPABASE_URL;
const SUPABASE_KEY = process.env.REACT_APP_CRM_SUPABASE_KEY;

class RealtimeService {
  constructor() {
    if (!SUPABASE_URL || !SUPABASE_KEY) {
      console.error('❌ CRM Supabase credentials not configured');
      this.client = null;
      return;
    }

    this.client = createClient(SUPABASE_URL, SUPABASE_KEY);
    this.subscriptions = [];
    console.log('✅ CRM Realtime conectado:', SUPABASE_URL);
  }

  subscribeToMessages(conversationId, callback) {
    if (!this.client) return null;

    const subscription = this.client
      .channel(`messages:${conversationId}`)
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'messages',
          filter: `conversation_id=eq.${conversationId}`,
        },
        (payload) => {
          console.log('📨 Nova mensagem CRM:', payload.new);
          callback(payload.new);
        }
      )
      .subscribe();

    this.subscriptions.push(subscription);
    return subscription;
  }

  subscribeToConversations(sellerId, callback) {
    if (!this.client) return null;

    const subscription = this.client
      .channel('conversations')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'conversations',
          filter: `seller_id=eq.${sellerId}`,
        },
        (payload) => {
          console.log('💬 Conversa CRM atualizada:', payload);
          callback(payload);
        }
      )
      .subscribe();

    this.subscriptions.push(subscription);
    return subscription;
  }

  // NOVO: Escuta especificamente NOVAS conversas (INSERT)
  subscribeToNewConversations(sellerId, callback) {
    if (!this.client) return null;

    const subscription = this.client
      .channel('new-conversations')
      .on(
        'postgres_changes',
        {
          event: 'INSERT',  // Apenas novos registros
          schema: 'public',
          table: 'conversations',
          filter: `seller_id=eq.${sellerId}`,
        },
        (payload) => {
          console.log('🆕 Nova conversa criada!', payload.new);
          callback(payload.new);
        }
      )
      .subscribe();

    this.subscriptions.push(subscription);
    return subscription;
  }

  unsubscribeAll() {
    if (!this.client) return;
    this.subscriptions.forEach((sub) => {
      this.client.removeChannel(sub);
    });
    this.subscriptions = [];
  }
}

export default new RealtimeService();